import { config } from './configPortal';

export const lkidListHeaderByArea = {
    BUY: {
        USED_CARS: 1811,
        NEW_CARS: 1812,
        USED_MOTORCYCLES: 1813,
        NEW_MOTORCYCLES: 1814,
    },
    SELL: {
        SELL_MY_VEHICLE: 1816,
        SELL_MY_MOTORCYCLE: 1817,
        MANAGER_MY_AD: 1818,
        DEALER_PLATFORM: 1819,
    },
    SERVICES: {
        FIPE_TABLE_WEBMOTORS: 1820,
        FINANCING: 1821,
        CATALOGO_KM: 1822,
        DEALER_PLATFORM: 1824,
        SAFE: 1825,
    },
    NOTICES: {
        PORTAL: 1826,
        LATEST_NEWS: 1827,
        TEST: 1828,
        COMPARATIVES: 1829,
        VIDEOS: 1830,
        MOTORCYCLES: 1831,
        SECRETS: 1832,
        TIPS: 1833,
        POCKET: 1834,
    },
    HELP: {
        CONTATC_US: 1835,
        DEALERSHIP_STORES: 1836,
        SAFE: 1837,
    },
};

const { BUY, SELL, SERVICES, NOTICES, HELP } = lkidListHeaderByArea;
const currentUrl = config.urlWebApp;
export const linksHeader = [
    {
        area: 'Comprar',
        dataQa: 'header-buy-vehicles',
        children: [
            {
                name: 'Carros usados',
                id: 'navigationUsedOrNewCars',
                classIcon: 'icon--buy-car',
                urlName: 'carros-usados-ou-seminovos',
                urlAddress: config.urlUsedOrNewCars,
                lkid: BUY.USED_CARS,
                dataQa: 'header-used-cars',
            },
            {
                name: 'Carros novos',
                id: 'navigationUsedOrNewCars',
                classIcon: 'icon--buy-new-car',
                urlName: 'carros-novos',
                urlAddress: config.urlNewCars,
                lkid: BUY.NEW_CARS,
                dataQa: 'header-new-cars',
            },
            {
                name: 'Motos usadas',
                id: 'navigationUsedOrNewMotorbikes',
                classIcon: 'icon--buy-motorcycle',
                urlName: 'motos-usadas-ou-seminovas',
                urlAddress: config.urlUsedOrNewMotorbikes,
                lkid: BUY.USED_MOTORCYCLES,
                dataQa: 'header-used-motorcycles',
            },
            {
                name: 'Motos novas',
                id: 'navigationNewMotorsbike',
                classIcon: 'icon--buy-new-motorcycle',
                urlName: 'motos-novas',
                urlAddress: config.urlNewMotorsbike,
                lkid: BUY.NEW_MOTORCYCLES,
                dataQa: 'header-new-motorcycles',
            },
            {
                name: 'Vistoriado',
                id: 'navigationInspected',
                classIcon: 'icon--inspected',
                urlName: 'vistoriado',
                urlAddress: config.urlInspected,
                lkid: '',
                dataQa: 'header-inspected',
            },
        ],
    },
    {
        area: 'Vender',
        dataQa: 'header-sell-vehicles',
        children: [
            {
                name: 'Vender carro',
                id: 'navigationSellMyCar',
                classIcon: 'icon--sell-car',
                urlName: 'vender-meu-carro',
                urlAddress: config.urlSellMyCar,
                lkid: SELL.SELL_MY_VEHICLE,
                dataQa: 'header-sell-cars',
            },
            {
                name: 'Vender moto',
                id: 'navigationSellMyBike',
                classIcon: 'icon--sell-motorcycle',
                urlName: 'vender-minha-moto',
                urlAddress: config.urlSellMyBike,
                lkid: SELL.SELL_MY_MOTORCYCLE,
                dataQa: 'header-sell-motorcycles',
            },
            {
                name: 'Gerenciar meu anúncio',
                id: 'navigationManageAdvertising',
                classIcon: 'icon--sell-garage',
                urlName: 'gerenciar-meu-anuncio',
                urlAddress: config.urlManageMyAdvertising,
                lkid: SELL.MANAGER_MY_AD,
                dataQa: 'header-manage-ads',
            },
            {
                name: 'Plataforma revendedores',
                id: 'navigationDealerPlatform',
                classIcon: 'icon--sell-odometer',
                urlName: '',
                urlAddress: config.urlCockPit,
                lkid: SELL.DEALER_PLATFORM,
                dataQa: 'header-cockpit',
            },
        ],
    },
    {
        area: 'Serviços',
        dataQa: 'header-services',
        children: [
            {
                name: 'Tabela FIPE e Tabela Webmotors',
                id: 'navigationFipe',
                classIcon: 'icon--table-fipe',
                urlName: 'tabela-fipe',
                urlAddress: config.urlTableFipe,
                lkid: SERVICES.FIPE_TABLE_WEBMOTORS,
                dataQa: 'header-fipe',
            },
            {
                name: 'Financiamento',
                id: 'navigationFinancing',
                classIcon: 'icon--financing',
                urlName: 'financiamento',
                urlAddress: config.urlFinancig,
                lkid: SERVICES.FINANCING,
                dataQa: 'header-financing',
            },
            {
                name: 'Catálogo 0km',
                id: 'navigationKM',
                classIcon: 'icon--service-catalogo',
                urlName: '0km',
                urlAddress: config.urlKM,
                lkid: SERVICES.CATALOGO_KM,
                dataQa: 'header-catalog',
            },
            {
                name: 'Plataforma revendedores',
                id: 'navigationDealer',
                classIcon: 'icon--sell-odometer',
                urlName: 'plataforma-revendedor',
                urlAddress: config.urlCockPit,
                lkid: SERVICES.DEALER_PLATFORM,
                dataQa: 'header-platfortm',
            },
            {
                name: 'Seguro veículo',
                id: 'navigationSafe',
                classIcon: 'icon--service-car-insurance',
                urlName: 'seguro',
                urlAddress: config.urlAutoCompara,
                lkid: SERVICES.SAFE,
                dataQa: 'header-',
            },
        ],
    },
    {
        area: 'Notícias WM1',
        dataQa: 'header-notices-wm1',
        children: [
            {
                name: 'Portal',
                id: 'navigationNoticesPortal',
                classIcon: 'icon--km',
                urlName: 'portal',
                urlAddress: config.urlPortal,
                lkid: NOTICES.PORTAL,
                dataQa: 'header-portal',
            },
            {
                name: 'Últimas notícias',
                id: 'navigationNoticesNewsWM1',
                classIcon: 'icon--news-wm1',
                urlName: 'noticias-wm1',
                urlAddress: config.urlNewsWM1,
                lkid: NOTICES.LATEST_NEWS,
                dataQa: 'header-latest-news',
            },
            {
                name: 'Testes',
                id: 'navigationNoticesTests',
                classIcon: 'icon--tests-car',
                urlName: 'testes',
                urlAddress: config.urlNewsWM1Tests,
                lkid: NOTICES.TEST,
                dataQa: 'header-tests-news',
            },
            {
                name: 'Comparativos',
                id: 'navigationnoticesComparatives',
                classIcon: 'icon--comparative-car',
                urlName: 'comparativos',
                urlAddress: config.urlNewsWM1Comparative,
                lkid: NOTICES.COMPARATIVES,
                dataQa: 'header-comparative-news',
            },
            {
                name: 'Vídeos',
                id: 'navigationNoticesVideos',
                classIcon: 'icon--videos',
                urlName: 'videos',
                urlAddress: config.urlNewsWM1Videos,
                lkid: NOTICES.VIDEOS,
                dataQa: 'header-video-news',
            },
            {
                name: 'Motos',
                id: 'navigationNoticesMotorcycle',
                classIcon: 'icon--notices-motorcycle',
                urlName: 'motos',
                urlAddress: config.urlNewsWM1Motorcycles,
                lkid: NOTICES.MOTORCYCLES,
                dataQa: 'header-motorcycle-news',
            },
            {
                name: 'Segredos',
                id: 'navigationNoticesSecrets',
                classIcon: 'icon--secrets',
                urlName: 'segredos',
                urlAddress: config.urlNewsWM1Secrets,
                lkid: NOTICES.SECRETS,
                dataQa: 'header-secrets-news',
            },
            {
                name: 'Dicas',
                id: 'navigationNoticesTips',
                classIcon: 'icon--tips',
                urlName: 'dicas',
                urlAddress: config.urlNewsWM1Tips,
                lkid: NOTICES.TIPS,
                dataQa: 'header-tips-news',
            },
            {
                name: 'Bolso',
                id: 'navigationNoticesPocket',
                classIcon: 'icon--pocket',
                urlName: 'bolso',
                urlAddress: config.urlNewsWM1Pocket,
                lkid: NOTICES.POCKET,
                dataQa: 'header-pocket-news',
            },
        ],
    },
    {
        area: 'Ajuda',
        dataQa: 'header-help',
        children: [
            {
                name: 'Para você',
                id: 'navigationContatcUs',
                classIcon: 'icon--person-one',
                urlName: 'para-voce',
                urlAddress: config.urlContatcUs,
                lkid: HELP.CONTATC_US,
                dataQa: 'header-contact',
            },
            {
                name: 'Para a sua loja',
                id: 'navigationYourStore',
                classIcon: 'icon--persons',
                urlName: 'para-sua-loja',
                urlAddress: config.urlYourStore,
                lkid: HELP.DEALERSHIP_STORES,
                dataQa: 'header-',
            },
            {
                name: 'Segurança',
                id: 'navigationSafety',
                classIcon: 'icon--safety',
                urlName: 'seguranca',
                urlAddress: config.urlSafety,
                lkid: HELP.SAFE,
                dataQa: 'header-',
            },
        ],
    },
];
